var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 8,
    viewBox: "0 0 3 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.76725 2.83511L0.878003 3.07188L0.810353 3.38538L1.1816 3.45386C1.42415 3.51161 1.472 3.59906 1.4192 3.84078L0.810353 6.70188C0.650303 7.44191 0.896978 7.79006 1.47695 7.79006C1.92658 7.79006 2.4488 7.58216 2.68558 7.29671L2.75818 6.95351C2.59318 7.09871 2.35228 7.15646 2.19223 7.15646C1.96535 7.15646 1.88285 6.99723 1.94143 6.71673L2.76725 2.83511ZM2.825 1.11251C2.825 1.33131 2.73808 1.54115 2.58337 1.69587C2.42865 1.85059 2.21881 1.93751 2 1.93751C1.7812 1.93751 1.57136 1.85059 1.41664 1.69587C1.26192 1.54115 1.175 1.33131 1.175 1.11251C1.175 0.893703 1.26192 0.683861 1.41664 0.529143C1.57136 0.374425 1.7812 0.287506 2 0.287506C2.21881 0.287506 2.42865 0.374425 2.58337 0.529143C2.73808 0.683861 2.825 0.893703 2.825 1.11251Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI);
export default __webpack_public_path__ + "static/media/i.9c7760818dbd34c1a0f65565dba607aa.svg";
export { ForwardRef as ReactComponent };